import React from "react";
import { useParams } from "react-router-dom";

const Footer = () => {
  const { templateId } = useParams();
  const today = new Date();

  const renderSocial = () => {
    switch (templateId) {
      case "1":
        return (
          <div className="socialIcons">
            <a
              href="https://goo.gl/zoKp4Z"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-google fa-2x"></i>
            </a>
            <a
              href="https://www.yelp.com/biz/bowinkles-restaurant-rio-linda"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-yelp fa-2x"></i>
            </a>
            <a
              href="https://www.facebook.com/pages/Bowinkles/152251514818823"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook-f fa-2x"></i>
            </a>
          </div>
        );
      case "2":
        return (
          <div className="socialIcons">
            <a
              href="https://goo.gl/zoKp4Z"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-google fa-2x"></i>
            </a>
            <a
              href="https://www.yelp.com/biz/bowinkle-drive-thru-rancho-cordova"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-yelp fa-2x"></i>
            </a>
            <a
              href="https://www.facebook.com/Bowinkle-Drive-Thru-Rancho-112045923495549/?rf=258331081514609"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook-f fa-2x"></i>
            </a>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="footerContainer">
      <footer className="text-center">
        {renderSocial()}
        <p>
          &copy; {today.getFullYear()} Bowinkles Drive Thru. All Rights
          Reserved.
        </p>
      </footer>
    </div>
  );
};

export default Footer;
